import { api } from '@/api';
import { useStudyGuard } from '@/shared/guard';
import { useIsQualityReviewApplicable } from '@/shared/hook';

import { validateQualityControl } from '../util';
import { useFilteredQualityControl } from './use-filtered-quality-control.hook';

export function useValidateQualityControl(): boolean {
  const { studyId } = useStudyGuard();
  const isQualityReviewApplicable = useIsQualityReviewApplicable();

  const { data, isError } = api.fct.qualityControl.query.useGetQualityControl(
    { payload: { studyId } },
    { enabled: false },
  );

  const filteredData = useFilteredQualityControl(data);

  if (!isQualityReviewApplicable) {
    return true;
  }

  if (isError) {
    return false;
  }

  if (!filteredData) {
    return true;
  }

  return validateQualityControl(filteredData);
}
